<template>
  <div>
    <template v-if="visibility('dashboard_access')">
      <div class="my-3 mx-4 uppercase text-gray-300 text-xs">
        {{ $t('General') }}
      </div>
      <menu-item :label="$t('Dashboard')" :mobile="mobile" icon="font-awesome.tachometer-alt-regular" to="/admin/dashboard"></menu-item>
    </template>

    <template v-if="visibility('repairs_manage')">
      <div class="my-3 mx-4 uppercase text-gray-300 text-xs">
        {{ $t('Workshop') }}
      </div>
      <menu-item :label="$t('Repair Orders')" :mobile="mobile" icon="font-awesome.tools-solid" to="/admin/repair-orders"></menu-item>
    </template>

    <div v-if="groupVisibility(dataEnteryGates)" class="my-3 mx-4 uppercase text-gray-300 text-xs">
      {{ $t('Data Entries') }}
    </div>

    <menu-item :label="$t('Brands')" :mobile="mobile" icon="font-awesome.folder-open-regular" to="/admin/brands" v-show="visibility('manage_repairable_brands')"></menu-item>
    <menu-item
      :label="$t('Repairable Devices')"
      :mobile="mobile"
      icon="font-awesome.folder-open-regular"
      to="/admin/repairable-devices"
      v-show="visibility('manage_repair_devices')"
    ></menu-item>
    <menu-item
      :label="$t('Repairable Defects')"
      :mobile="mobile"
      icon="font-awesome.folder-open-regular"
      to="/admin/repairable-defects"
      v-show="visibility('manage_repair_defects')"
    ></menu-item>

    <div v-if="groupVisibility(toolGates)" class="my-3 mx-4 uppercase text-gray-300 text-xs">
      {{ $t('Tools') }}
    </div>
    <menu-item :label="$t('Quick Replies')" :mobile="mobile" icon="font-awesome.reply-all-solid" to="/admin/quick-replies" v-show="visibility('manage_quick_replies')"></menu-item>
    <menu-item :label="$t('Repair Statuses')" :mobile="mobile" icon="font-awesome.tags-solid" to="/admin/repair-statuses" v-show="visibility('manage_reply_statuses')"></menu-item>
    <menu-item
      :label="$t('Repair Priorities')"
      :mobile="mobile"
      icon="font-awesome.list-ol-solid"
      to="/admin/repair-priorities"
      v-show="visibility('manage_repair_priorities')"
    ></menu-item>
    <menu-item :label="$t('Custom Pages')" :mobile="mobile" icon="font-awesome.link-solid" to="/admin/custom-pages" v-show="visibility('manage_custom_page')"></menu-item>

    <menu-item :label="$t('FAQ')" :mobile="mobile" icon="font-awesome.question-circle-solid" to="/admin/faq" v-show="visibility('manage_faq')"></menu-item>

    <menu-item :label="$t('Report')" :mobile="mobile" icon="font-awesome.clipboard-list-solid" to="/admin/report" v-show="visibility('report_access')"> </menu-item>

    <div v-if="groupVisibility(authGates)" class="my-3 mx-4 uppercase text-gray-300 text-xs">
      {{ $t('Administration') }}
    </div>
    <menu-item :label="$t('Users')" :mobile="mobile" icon="font-awesome.users-solid" to="/admin/users" v-show="visibility('manage_users')"></menu-item>
    <menu-item :label="$t('User roles')" :mobile="mobile" icon="font-awesome.user-lock-solid" to="/admin/user-roles" v-show="visibility('manage_user_roles')"></menu-item>

    <div v-if="groupVisibility(systemGates) || groupVisibility(settingGates)" class="my-3 mx-4 uppercase text-gray-300 text-xs">
      {{ $t('System') }}
    </div>
    <template v-if="groupVisibility(settingGates)">
      <menu-item :label="$t('Settings')" :mobile="mobile" icon="font-awesome.cogs-solid" to="/admin/settings"></menu-item>
    </template>
    <menu-item :label="$t('Backup')" :mobile="mobile" icon="font-awesome.database-solid" to="/admin/backup" v-show="visibility('database_backup')"></menu-item>
    <menu-item :label="$t('Translations')" :mobile="mobile" icon="font-awesome.globe-solid" to="/admin/languages" v-show="visibility('manage_translations')"></menu-item>
  </div>
</template>
<script>
import { includes, forEach } from 'lodash';
import MenuItem from '@/components/layout/admin/menu/menu-item';

export default {
  name: 'menu-list',
  components: { MenuItem },
  props: {
    mobile: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      dataEnteryGates: ['manage_repair_devices', 'manage_repair_defects', 'manage_repairable_brands'],
      authGates: ['manage_users', 'manage_user_roles'],
      toolGates: ['manage_quick_replies', 'manage_reply_statuses', 'manage_repair_priorities', 'manage_custom_page', 'manage_faq', 'report_access'],
      systemGates: ['database_backup', 'manage_translations'],
      settingGates: [
        'general_configuration',
        'outgoing_mail_configuration',
        'sms_configuration',
        'currency_configuration',
        'gateways_configuration',
        'tax_configuration',
        'seo_configuration',
        'appearance_configuration',
        'authentication_configuration',
        'captcha_configuration',
        'localization_configuration',
        'terms_condition',
      ],
    };
  },
  computed: {
    permissions() {
      return this.$store.state.permissions;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    visibility(key) {
      if (this.user.role_id < 2) {
        return true;
      }
      return includes(this.permissions, key);
    },
    groupVisibility(keys) {
      if (this.user.role_id < 2) {
        return true;
      }
      let permit = false;
      forEach(keys, (key) => {
        if (includes(this.permissions, key)) {
          permit = true;
        }
      });
      return permit;
    },
  },
};
</script>
